import { ContainerTheme } from 'src/components/container/container-theme';

export const largeContainerStyles: ContainerTheme = {
  maxWidth: '1200px',
};
